import "./preinit"
import "bootstrap/scss/bootstrap.scss"
import "./stylesheets/index.scss"
import "./stylesheets/common/base.scss"
import "./stylesheets/common/buttons.scss"
import "./stylesheets/common/typography.scss"

import React from "react"
import { createRoot } from "react-dom/client"

// import './index.css';
//import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { StackerElement } from "components/DYStackers/DYStackers"
import { App } from "testing/App"
import LegacyI18n from "components/DYStackers/LegacyI18n"
import { getStoreInstance } from "store"
import DYApp from "components/DYStackers/DYApp"
import BodyPage from "components/BodyPage"

const container = document.getElementById("teststacker")

if (container) {
  reportWebVitals(console.log)
}

// const instance = document.querySelector("dy-stackers")
// if (instance) {
//   const shadowRoot =
//     instance.shadowRoot || instance.attachShadow({ mode: "open" })
//   const reactRoot = shadowRoot.querySelector("#mainContentArea")
//   instance.id = "mainContentArea"
//   instance.style.flex = "1 1 0"
//   instance.className = "bg-white"

//   const root = createRoot(reactRoot)
//   root.render(
//     <React.StrictMode>
//       <StackerElement />
//     </React.StrictMode>
//   )
// }
